export default "__VITE_ASSET__0Y8fZEPW__"